module.exports = __webpack_public_path__ + "img/img12.8cce67dd.svg";